import { message } from 'antd'
import { useLingui } from '@lingui/react/macro'

import { useCoverStore } from '../../../_store/useCoverStore'

import type { CoverFormValues } from '../../../_types/form'

import { EFeatureName, useFeatureGuard } from '@/hooks/usageValidation'
import { useTrackCommonParams } from '@/hooks/analyticsData/trackCommonParams'


import { api } from '@/utils/api';
export function useCoverSubmit(options?: { onSuccess?: () => void }) {
  const { t } = useLingui()
  const setUI = useCoverStore((s) => s.setUI)
  const guardGenerate = useFeatureGuard(EFeatureName.Generate, {
    triggerMethod: 'ai_cover_check',
    signUpParams: {
      triggerLocation: 'generate_cover_music',
      triggerType: 'create',
    },
  })
  const getCommonParamsRef = useTrackCommonParams()
  const { mutateAsync: createTask } = api.cover.createTask.useMutation({
    onSuccess: () => {
      message.success(t`Cover task created successfully!`)
      options?.onSuccess?.()
    },
  })

  const handleSubmit = guardGenerate(async (formValues: CoverFormValues) => {
    if (!formValues.referenceAudio?.token) {
      message.error(t`Please upload an audio file to get started.`)
      return
    }

    const isCustom = formValues.mode === 'custom'
    const prompt = isCustom ? formValues.customPrompt : formValues.smartPrompt

    try {
      setUI({ isSubmitting: true })
      const { commonParams: trackingContext } =
        await getCommonParamsRef.current()
      await createTask({
        mode: formValues.mode,
        prompt: prompt || undefined,
        instrumental: !isCustom ? formValues.instrumental : undefined,
        referenceAudio: formValues.referenceAudio.token,
        style: isCustom ? formValues.style : undefined,
        advanced: isCustom
          ? {
              vocalGender: formValues.advanced.vocalGender,
              styleWeight: formValues.advanced.styleWeight,
              creativeWeight: formValues.advanced.creativeWeight,
              audioWeight: formValues.advanced.audioWeight,
            }
          : undefined,
        trackingContext,
      })
    } finally {
      setUI({ isSubmitting: false })
    }
  })

  return {
    handleSubmit,
  }
}
